import React from 'react';
import sortBy from 'lodash/sortBy';

import {
    Context as ChartContextProps,
    ChartConsumer,
} from '@ihme/common/web/components/ChartProvider';
import { DataRecord } from '@ihme/common/types';

import config from '../../../../config';

import View from './View';

type Props = ChartContextProps & {
    locationId: number;
};

class Highlight extends React.PureComponent<Props> {
    getData = (): {
        id: number;
        year: number;
        value: number;
    }[] => {
        const { columns, records, locationId } = this.props;

        const yearIndex = columns.indexOf('year');
        const locationIdIndex = columns.indexOf('location_id');
        const valueIndex = columns.indexOf('value');

        const filteredRecords = records.filter((record:DataRecord) =>
            (record[yearIndex] === 2000 || record[yearIndex] === 2022)
            && (record[locationIdIndex] === config.globalLocationId || record[locationIdIndex] === locationId)
        );

        return sortBy(filteredRecords.map((record:DataRecord) =>({
            id: record[locationIdIndex],
            year: record[yearIndex],
            value: record[valueIndex],
        })), ['locationId', 'year']);
    };

    render() {
        const { locationId, isLoadingData } = this.props;

        return (
            <View
                isLoading={isLoadingData}
                locationId={locationId}
                data={this.getData()}
            />
        );
    }
}

export default props => (
    <ChartConsumer>
        {consumerProps => <Highlight {...consumerProps} {...props} />}
    </ChartConsumer>
);
